import { initialDateFormat, User } from '@griply/types';

export const getDateFormat = (user?: User | null) =>
  user?.settings?.dateFormat ?? initialDateFormat;
